enum Gender {
  Unspecified = 0,
  Male = 1,
  Female = 2,
  Other = 9,
}

export default Gender;
